import { GetServerSideProps } from 'next'

import { AppLayout } from '@components/layouts/AppLayout'
import { WithAllCategoryPageProps } from '@features/allCategory/pages/AllCategoryPage/interface'
import { AllCategoryPage } from '@features/allCategory/pages/AllCategoryPage'
import { MenuTypeEnum } from '@interfaces/MenuTypeEnum'
import { PrimaryTypeEnum } from '@interfaces/PrimaryTypeEnum'
import { OrderedKeyEnum } from '@interfaces/OrderedEnum'
import { SortEnum } from '@interfaces/SortEnum'
import { OgShare } from '@components/OgShare'
import { BASE_URL } from '@configs/config'
import { isMaintenanceHandler } from '@lib/maintenanceHandler'
import { AppLinkMeta } from '@components/AppLinkMeta'

function AllCategory(props: WithAllCategoryPageProps) {
  const {
    url,
    bookType,
    categoryId,
    primaryType,
    queryOrderBy,
    querySecondaryType,
  } = props

  // Build query parameters for deeplink
  const queryParams = new URLSearchParams()
  if (bookType) queryParams.append('bookType', bookType)
  if (categoryId) queryParams.append('categoryId', categoryId)
  if (primaryType) queryParams.append('primaryType', primaryType)
  if (queryOrderBy) queryParams.append('orderBy', queryOrderBy)
  if (querySecondaryType)
    queryParams.append('secondaryType', querySecondaryType)

  const deeplinkUrl = queryParams.toString() ? `?${queryParams.toString()}` : ''

  return (
    <AppLayout>
      <AppLinkMeta path={`all-category${deeplinkUrl}`} webUrl={url} />
      <OgShare url={url} />
      <AllCategoryPage {...props} />
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  query,
  req,
}) => {
  const isMaintenance = await isMaintenanceHandler()
  if (isMaintenance) {
    return {
      redirect: {
        destination: '/maintenance',
        permanent: false,
      },
      props: {
        isMaintenance: !!isMaintenance,
      },
    }
  }

  if (
    ![MenuTypeEnum.MANGA, MenuTypeEnum.NOVEL].includes(
      query.bookType as MenuTypeEnum
    )
  ) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
      props: {
        isMaintenance: !!isMaintenance,
      },
    }
  }

  const categoryDetail =
    query.bookType === MenuTypeEnum.MANGA
      ? 'รวมเรื่องราวที่หลากหลายไม่ว่าจะเป็น มังงะ Webcomic หรือ Webtoon ที่มีการ์ตูนหลากหลายแนว มาให้เลือกอ่านกันได้ตามชอบ ไม่ว่าจะเป็น การ์ตูนวาย การ์ตูนยูริ การ์ตูนแฟนตาซี หรือ การ์ตูนแอคชั่น ต่าง ๆ กับภาพวาดที่สวยงาม และเรื่องราวที่ชวนติดตาม จากนักเขียนและนักวาดที่มากฝีมือของทั้ง Webtoon เกาหลี จีน และไทย  มีลายเส้นที่เป็นเอกลักษณ์ ให้อ่านได้เพลิน ๆ บางเรื่องก็ถูกนำมาสร้างเป็นภาพยนตร์ หรือ ซีรีส์ลง Netflix ก็มีเช่นกัน เรายังมีการ์ตูนอีกมากมาย ทั้งการ์ตูน Exclusive การ์ตูนออริจินัล การ์ตูนแปล การ์ตูนแปลจีน  (Manhwa / ม่านฮวา) การ์ตูนแปลเกาหลี (Manhwa / มังฮวา) การ์ตูนแปลญี่ปุ่น (Manga) มาทั้งในรูปแบบของการ์ตูนฟรี การ์ตูนไม่ติดเหรียญ และการ์ตูนติดเหรียญ ให้คุณได้เต็มอิ่มไปกับการ์ตูนออนไลน์ และ E-Book ที่อ่านได้ทั้งบนเว็บไซต์ และ แอปพลิเคชัน MaReads แล้วยังให้คุณได้สนับสนุนตัวละครที่คุณรัก เพื่อเป็นกำลังใจให้กับนักเขียน นักวาด และสนับสนุนงานของพวกเขาได้อีกด้วย ซึ่งความพิเศษแบบนี้มีแค่ที่ MaReads เท่านั้น'
      : 'รวมนิยายหลากหลายแนวที่คุณไม่ควรพลาด อ่านง่าย อ่านสนุกที่ MaReads ไม่ว่าจะเป็นแนว นิยายวาย (Yaoi) นิยายยูริ (Yuri) นิยายรัก นิยายรักโรแมนติก นิยายโรแมนซ์ นิยายแฟนตาซี ไซไฟ ผจญภัย นิยายแอคชั่น นิยายกำลังภายใน นิยายจีนโบราณ นิยายสืบสวนสอบสวน นิยายสยองขวัญ นิยายคอมเมดี้ หรือวรรณกรรมเยาวชน หลายเรื่องเป็นเรื่องดังที่เคยถูกทำเป็นซีรีส์มาแล้ว เรายังมีนิยาย อีกมากมาย ทั้งนิยาย Exclusive นิยายแปล นิยายแปลจีน นิยายออริจินัล มาทั้งในรูปแบบของนิยายฟรี นิยาย ฟรี อ่านจบ ไม่ติดเหรียญ และนิยายติดเหรียญ ให้คุณได้เต็มอิ่มไปกับนิยายออนไลน์ และ E-Book ที่อ่านได้ทั้งบนเว็บไซต์ และ แอปพลิเคชัน MaReads แล้วยังให้คุณได้สนับสนุนตัวละครที่คุณรัก เพื่อเป็นกำลังใจให้กับนักเขียน นักวาด และสนับสนุนงานของพวกเขาได้อีกด้วย ซึ่งความพิเศษแบบนี้มีแค่ที่ MaReads เท่านั้น'

  return {
    props: {
      categoryId: query.categoryId || '',
      primaryType: query.primaryType || PrimaryTypeEnum.TOP_CHART,
      queryOrderBy:
        query.orderBy || `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
      querySecondaryType: query.secondaryType || null,
      advanceSearch: query.advanceSearch === 'true',
      bookType: query.bookType,
      title: query.bookType === MenuTypeEnum.MANGA ? 'การ์ตูน' : 'นิยายรายตอน',
      categoryDetail,
      url: `${BASE_URL}${req.url}`,
      isMaintenance: false,
    },
  }
}

export default AllCategory
